/**
 * ThemeInitializer Component
 * 
 * Initializes theme on app load and syncs with next-themes.
 * Ensures theme preference is restored from localStorage on page load.
 */

import { useEffect } from 'react'
import { useTheme as useNextTheme } from 'next-themes'
import { initializeTheme } from '@appic/config'

export function ThemeInitializer() {
  const { resolvedTheme, theme: colorScheme } = useNextTheme()
  const isDark = resolvedTheme === 'dark'

  useEffect(() => {
    // Initialize theme on mount - this loads theme ID from localStorage
    // and applies it to the document
    initializeTheme(isDark)
  }, [isDark])

  // Ensure theme is applied when color scheme changes
  useEffect(() => {
    if (colorScheme && resolvedTheme) {
      // Re-initialize theme when color scheme changes to ensure it's applied
      initializeTheme(isDark)
    }
  }, [colorScheme, resolvedTheme, isDark])

  return null
}
